import React, { useEffect, useRef, useState } from 'react';

import { Carousel, CarouselNavigation, CarouselSlide, CarouselWrapper } from '$partials/base/carousel';
import { Image } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/modules.d.ts').ImageCarousel}
 */
const ImageCarousel = ({
    items,
}) => {
    const [videoHeight, setVideoHeight] = useState(undefined);
    const [videoWidth, setVideoWidth] = useState(undefined);
    const videoRef = useRef();

    const handleVideoLoad = () => {
        setVideoHeight(videoRef.current.videoHeight);
        setVideoWidth(videoRef.current.videoWidth);
    };

    useEffect(() => {
        const video = videoRef.current;

        if (video) {
            video.addEventListener('loadedmetadata', handleVideoLoad, { passive: true });

            window.setTimeout(() => {
                handleVideoLoad();
            }, 100);
        }

        return () => {
            if (video) {
                video.removeEventListener('loadedmetadata', handleVideoLoad, { passive: true });
            }
        };
    }, []);

    return (
        <Carousel swiperConfig={{
            slidesPerView: 'auto',
            spaceBetween: 20,
            breakpoints: {
                640: {
                    slidesPerView: 'auto',
                    spaceBetween: 20
                },
                1024: {
                    slidesPerView: 'auto',
                    spaceBetween: 30
                }
            },
        }}>
            <div className='overflow-hidden container overhang-left'>
                <CarouselWrapper className='swiper-wrapper'>
                    <div className={'absolute-center-y z2 image-carousel-navigation'}>
                        <CarouselNavigation look='col' />
                    </div>
                    {items?.map((item, i) => {
                        if (!item?.image) { return null; }

                        return (
                            <CarouselSlide
                                className='flex'
                                index={i}
                                key={item?.image?.id}>
                                <div className='flex flex-col image-carousel-fixed-height'>
                                    {item.video ? (
                                        <div style={{
                                            width: `${(videoWidth / videoHeight) * 0.8}em`,
                                        }}>
                                            <video
                                                autoPlay
                                                loop
                                                muted
                                                playsInline
                                                ref={videoRef}
                                                src={item.video.videoUrl}/>
                                        </div>
                                    ) : (
                                        <div style={{
                                            width: `${(item.image?.width / item.image?.height) * 0.8}em`
                                        }}>
                                            <Image {...item.image} />
                                        </div>
                                    )}
                                    {item.caption && (
                                        <figcaption
                                            className='pt3'>
                                            <div
                                                className='rich-text type-style-7'
                                                dangerouslySetInnerHTML={{__html: item.caption}} />
                                        </figcaption>
                                    )}
                                </div>
                            </CarouselSlide>
                        );
                    })}
                </CarouselWrapper>

            </div>
        </Carousel>

    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ImageCarousel;
